<script>

export default {

	name: 'RouterMixin',
	methods: {

		goBack() {

			this.$router.back()

		},

		goToResultados() {

			this.$router.push('/resultados')

		},

		goToResultadosQuery(value) {

			this.$router.push({ name: 'Resultados', query: { codigoPesquisa: value } })

		},

		goToDadosQuery(codigoPesquisa, imovel) {

			if(imovel.regularidade.codigo === 'EM_PROCESSAMENTO' || imovel.regularidade.codigo === 'ERRO_INTERNO') {

				this.$notify({
					title: imovel.regularidade.nome,
					type: 'warning'
				})

				return

			}

			this.$router.push({ name: 'Dados', query: { codigoPesquisa: codigoPesquisa, idImovel: imovel.id }, params: { imovel: imovel } })

		},

		getRoute(view) {

			return view === this.route

		}

	}

}

</script>



// WEBPACK FOOTER //
// src/utils/mixins/RouterMixin.vue